module.exports = __webpack_public_path__ + "img/occupation_story_card2.290f18ad.svg";